import { NgModule } from '@angular/core';
import { LiquidChromeBackgroundComponent } from './liquid-chrome-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        LiquidChromeBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        LiquidChromeBackgroundComponent
    ]
})
export class NcLiquidChromeBackgroundModule { }